<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_mbAttchDlg_styleComponentAnimation()">
		<template v-if="$_mbAttchDlg_stateComponentIsInitialized">
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn"
							:color="isFalse(messageState_.attachmentFileUrl) ? 'secondary' : 'primary'"
							dark
							icon
							v-on="on"
							@click="$_mbAttchDlg_open()">
						<v-icon>attachment</v-icon>
					</v-btn>
				</template>
				<template v-if="!isFalse(messageState_.attachmentFileUrl)">
					<span v-text="messageState_.attachmentFileUrl" />
				</template>
				<template v-else>
					Not Set
				</template>
				<v-dialog
						v-model="show_"
						max-width="600px"
						persistent>
					<validation-observer v-slot="validation">
						<v-card>
							<v-card-title>Attachment File (MAX 5MB)</v-card-title>
							<v-card-text>
								<template v-if="isFalse(messageState_.attachmentFileUrl)">
									<validation-provider rules="required">
										<v-file-input
												accept=".jpeg,.jpg,.png,.txt,.csv,.pdf"
												color="success"
												hide-details
												label=".jpeg / .jpg / .png / .txt / .csv / .pdf"
												outlined
												:prepend-icon="null"
												show-size
												v-model="file_" />
									</validation-provider>
								</template>
								<template v-else>
									<v-row align="center" dense>
										<v-col>
											<v-text-field
													clearable
													hide-details
													outlined
													readonly
													v-model="messageState_.attachmentFileUrl" />
										</v-col>
										<v-col cols="auto">
											<clipboard-button :text="messageState_.attachmentFileUrl" />
										</v-col>
									</v-row>
								</template>
							</v-card-text>
							<v-card-actions>
								<v-row justify="center" dense>
									<v-col cols="auto">
										<v-btn	class="customVBtn"

												:disabled="(!validation.passed && !validation.valid) || $_mbAttchDlg_uploadOverSize()"

												:block="$_mbAttchDlg_styleSaveButtonBlock"
												:color="$_mbAttchDlg_styleSaveButtonColor"
												:dark="$_mbAttchDlg_styleSaveButtonDark"
												:depressed="$_mbAttchDlg_styleSaveButtonDepressed"
												:elevation="$_mbAttchDlg_styleSaveButtonElevation"
												:large="$_mbAttchDlg_styleSaveButtonLarge"
												:light="$_mbAttchDlg_styleSaveButtonLight"
												:outlined="$_mbAttchDlg_styleSaveButtonOutlined"
												:rounded="$_mbAttchDlg_styleSaveButtonRounded"
												:small="$_mbAttchDlg_styleSaveButtonSmall"
												:text="$_mbAttchDlg_styleSaveButtonFlat"
												@click="$_mbAttchDlg_save()">
											Save
										</v-btn>
									</v-col>
									<v-col cols="auto">
										<v-btn	class="customVBtn"

												:block="$_mbAttchDlg_styleCloseButtonBlock"
												
												:color="$_mbAttchDlg_styleCloseButtonColor"
												:dark="$_mbAttchDlg_styleCloseButtonDark"
												:depressed="$_mbAttchDlg_styleCloseButtonDepressed"
												:elevation="$_mbAttchDlg_styleCloseButtonElevation"
												:large="$_mbAttchDlg_styleCloseButtonLarge"
												:light="$_mbAttchDlg_styleCloseButtonLight"
												:outlined="$_mbAttchDlg_styleCloseButtonOutlined"
												:rounded="$_mbAttchDlg_styleCloseButtonRounded"
												:small="$_mbAttchDlg_styleCloseButtonSmall"
												:text="$_mbAttchDlg_styleCloseButtonFlat"
												@click="$_mbAttchDlg_close()">
											Close
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</validation-observer>
				</v-dialog>
			</v-tooltip>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MessagebarAttachmentDialog',
		data() {
			return {
				componentName_: 'messagebarAttachmentDialog',

				messageState_: {},

				show_: false,

				file_: null
			}
		},
		computed: {
			// state
			$_mbAttchDlg_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_mbAttchDlg_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mbAttchDlg_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_mbAttchDlg_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mbAttchDlg_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mbAttchDlg_inits(), 'component')
				}
			},
			$_mbAttchDlg_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mbAttchDlg_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mbAttchDlg_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_mbAttchDlg_inits(), 'chip')
			},
			$_mbAttchDlg_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_mbAttchDlg_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_mbAttchDlg_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_mbAttchDlg_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_mbAttchDlg_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_mbAttchDlg_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_mbAttchDlg_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_mbAttchDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			$_mbAttchDlg_styleCloseButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbAttchDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbAttchDlg_inits(), 'closeButton')
			},
			$_mbAttchDlg_styleCloseButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbAttchDlg_styleCloseButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbAttchDlg_styleCloseButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbAttchDlg_styleCloseButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbAttchDlg_styleCloseButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbAttchDlg_styleCloseButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbAttchDlg_styleCloseButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbAttchDlg_styleCloseButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbAttchDlg_styleCloseButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbAttchDlg_styleCloseButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbAttchDlg_styleCloseButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_mbAttchDlg_styleSaveButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbAttchDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbAttchDlg_inits(), 'saveButton')
			},
			$_mbAttchDlg_styleSaveButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbAttchDlg_styleSaveButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbAttchDlg_styleSaveButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbAttchDlg_styleSaveButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbAttchDlg_styleSaveButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbAttchDlg_styleSaveButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbAttchDlg_styleSaveButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbAttchDlg_styleSaveButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbAttchDlg_styleSaveButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbAttchDlg_styleSaveButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbAttchDlg_styleSaveButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbAttchDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			// file
			$_mbAttchDlg_uploadOverSize() {
				const self_ = this;
				return () => {
					return !self_.isFalse(self_.file_) && (self_.file_.size > 5000000) // 5MB
				}
			}
		},
		beforeMount() {
			const self_ = this;

			self_.messageState_ = self_.getState('message')
		},
		methods: {
			$_mbAttchDlg_open() {
				const self_ = this;
				self_.show_ = true;
			},
			$_mbAttchDlg_save() {
				const self_ = this;

				const name_ = self_.file_.name;
				const ext_ = name_.split('.')[1]
				const type_ = self_.file_.type;

				Promise.resolve().then(() => {
					if(type_ == 'text/plain' || ext_ == 'csv') {
						return self_.uploadFileText('Attachment Files', name_, self_.file_)
					}
					else if(type_ == 'image/jpeg' || type_ == 'image/png') {
						return self_.uploadFileImage('Attachment Files', name_, self_.file_)
					}
					else {
						return self_.uploadFileOther('Attachment Files', name_, self_.file_)
					}
				}).then(result => {
					self_.messageState_.attachmentFileUrl = result.url;

					self_.$_mbAttchDlg_close()
				})
			},
			$_mbAttchDlg_close() {
				const self_ = this;

				self_.file_ = null;
				
				self_.show_ = false;
			}
		}
	}
</script>

<style scoped>
	.row_ {
		min-height: 64px;
	}
	.overflow_ {
		max-width: 50px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
